<template>
  <!-- <div style="height: 700px"> -->
  <div class="scoringTableDiv">
    <div class="leftDiv">
      <div class="borderTop"></div>
      <div class="pd30">
        <div class="reTitle mt20">科技成果转化双推双促工程</div>
        <div class="reTitle mt20">《申报成果信息登记表》</div>
        <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">申报单位信息</div>
        </div>
        <el-descriptions :column="2" border label-width="120px">
          <el-descriptions-item
            labelClassName="labelClass"
            label="申报单位名称"
            :span="2"
            >{{ achievementDetail?.org_name }}</el-descriptions-item
          >
          <el-descriptions-item
            labelClassName="labelClass"
            label="单位所在省/市"
            >{{ achievementDetail?.org_province_name }}</el-descriptions-item
          >
          <el-descriptions-item
            labelClassName="labelClass"
            label="单位成立时间"
            >{{ achievementDetail?.establish_date }}</el-descriptions-item
          >
          <el-descriptions-item
            labelClassName="labelClass"
            label="单位产业属性"
            >{{ achievementDetail?.industrial_str }}</el-descriptions-item
          >
          <el-descriptions-item
            labelClassName="labelClass"
            label="单位业务属性"
            >{{ achievementDetail?.business_str }}</el-descriptions-item
          >
          <el-descriptions-item
            labelClassName="labelClass"
            label="单位从业人数（人）"
            >{{ achievementDetail?.org_person }}</el-descriptions-item
          >
          <el-descriptions-item
            labelClassName="labelClass"
            label="单位负责人姓名"
            >{{ achievementDetail?.org_leader }}</el-descriptions-item
          >
          <el-descriptions-item
            labelClassName="labelClass"
            label="成果申报人"
            >{{ achievementDetail?.declarant_name }}</el-descriptions-item
          >
          <el-descriptions-item
            labelClassName="labelClass"
            label="申报人联系方式"
            >{{ achievementDetail?.declarant_mobile }}</el-descriptions-item
          >
        </el-descriptions>

        <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">申报成果信息</div>
        </div>
        <el-descriptions
          :column="1"
          direction="vertical"
          border
          label-width="120px"
        >
          <el-descriptions-item label="申报成果名称">{{
            achievementDetail?.name
          }}</el-descriptions-item>
          <el-descriptions-item label="成果所属领域">{{
            achievementDetail?.scope_str
          }}</el-descriptions-item>
          <!-- <el-descriptions-item  label="成果简介" >
              <div v-html="achievementDetail?.profile"></div>
            </el-descriptions-item> -->
        </el-descriptions>

        <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">
            技术创新亮点<span class="formHeaderTextSpan"
              >（技术创新高度按项目所得最高荣誉选择）</span
            >
          </div>
        </div>
        <div>
          <el-descriptions direction="vertical" :column="3" border>
            <el-descriptions-item label="技术创新高度">{{
              achievementDetail?.height_str
            }}</el-descriptions-item>
            <el-descriptions-item label="技术创新属性">{{
              achievementDetail?.attribute_str
            }}</el-descriptions-item>
            <el-descriptions-item label="技术创新成果">{{
              achievementDetail?.achievement_str
            }}</el-descriptions-item>
          </el-descriptions>
        </div>

        <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">市场价值要点</div>
        </div>
        <div>
          <el-descriptions direction="vertical" :column="3" border>
            <el-descriptions-item label="核心产品市场形态">{{
              achievementDetail?.shape_str
            }}</el-descriptions-item>
            <el-descriptions-item label="项目已实现市场规模">{{
              achievementDetail?.scale_str
            }}</el-descriptions-item>
            <el-descriptions-item label="项目未来市场预期">{{
              achievementDetail?.expect_str
            }}</el-descriptions-item>
          </el-descriptions>
        </div>

        <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">转化要素难点</div>
        </div>
        <div>
          <el-descriptions direction="vertical" :column="3" border>
            <el-descriptions-item label="转化所需资源难度">{{
              achievementDetail?.difficulty_str
            }}</el-descriptions-item>
            <el-descriptions-item label="转化资源到位程度">{{
              achievementDetail?.degree_str
            }}</el-descriptions-item>
            <el-descriptions-item label="转化项目投资力度">{{
              achievementDetail?.strength_str
            }}</el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">转化已实现进程

          </div>
        </div> -->
        <!-- <div>
          <el-descriptions  direction="vertical" :column="1" border>
  <el-descriptions-item label="TRL1-9">1</el-descriptions-item>
        </el-descriptions>
        </div> -->

        <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">研发负责人</div>
        </div>
        <div>
          <el-descriptions direction="vertical" :column="3" border>
            <el-descriptions-item label="姓名">{{
              achievementDetail?.leader_name
            }}</el-descriptions-item>
            <el-descriptions-item label="学历">{{
              achievementDetail?.leader_education_str
            }}</el-descriptions-item>
            <el-descriptions-item label="职称">{{
              achievementDetail?.leader_title_str
            }}</el-descriptions-item>
          </el-descriptions>
        </div>

        <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">研发团队</div>
        </div>
        <div>
          <el-descriptions direction="vertical" :column="3" border>
            <el-descriptions-item label="团队人数">{{
              achievementDetail?.team_person_str
            }}</el-descriptions-item>
            <el-descriptions-item label="中级以上人员占比">{{
              achievementDetail?.team_intermediate_str
            }}</el-descriptions-item>
            <el-descriptions-item label="团队合作经验">{{
              achievementDetail?.team_experience_str
            }}</el-descriptions-item>
          </el-descriptions>
        </div>

        <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">附件上传</div>
        </div>
        <div v-for="value in achievementDetail?.attachment" :key="value.id">
          <div class="file-item" @click="handleDownload(value)">
            <i class="el-icon-document"></i>
            <el-button type="text">{{ value.file_name }}</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="rightDiv">
      <div class="reTitle mt20">中华科学交流基金会</div>
      <div class="reTitle mt20">科技成果转化项目双推双促工程</div>
      <div class="reTitle mt20">《新动能百优科技成果》提名</div>
      <div class="reTitle mt20">{{ scoreTitle }}</div>

      <div class="nameTitle mt20">申报名称：{{achievementDetail?.name}}</div>

      <div v-for="itemData in scoreList" :key="itemData.id" class="pfDiv">
        <div class="dfNum">{{ itemData.dimension_name }}</div>
        <div v-for="subItem in itemData.item" :key="subItem.id">
          <div class="dfTitle">{{ subItem.item_name }}</div>
          <div class="subTitle">{{ subItem.item_desc }}</div>
          <ScoringComponent
            v-model="subItem.currentScore"
            :maxScore="Number(subItem.score)"
            :minScore="Number(subItem.min_score)"
            :disabled="lookId == 1"
          />
        </div>

        <!-- <div class="dfTitle">二、技术成果所属领域先进程度</div>
          <ScoringComponent v-model="score2" label="领先" :maxScore="10" />
          <div class="dfTitle">三、技术产业创新融合作用强度</div>
          <ScoringComponent v-model="score3" label="重大" :maxScore="10" /> -->
        <div class="dfTitle mt10">
          指标得分：<span class="dfCountNum"
            ><span class="dfCountNumSpan">{{
              getDimensionScore(itemData)
            }}</span
            >分</span
          >
        </div>
      </div>
      <div class="dfTitle mt10 sumScore">
        总得分：<span class="dfCountNum"
          ><span class="dfCountNumSpan">{{ getTotalScore() }}</span
          >分</span
        >
      </div>
      <div>
        <div class="dfTitle">专家意见</div>
        <div>
          <el-input
            type="textarea"
            :disabled="lookId == 1"
            :autosize="{ minRows: 4, maxRows: 8 }"
            placeholder="请输入内容"
            v-model="opinionText"
          >
          </el-input>
        </div>
      </div>
      <div style="display: flex; justify-content: center; padding-top: 40px">
        <el-button
          type="primary"
          size="small"
          @click="submit"
          v-if="lookId == 0"
          >提交</el-button
        >
      </div>
    </div>
    <div class="goBack">
      <div class="goBackBtn">
        <el-button type="primary" size="small" @click="handleRow('goBack')"
          >返回</el-button
        >
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>
<script>
import ScoringComponent from "../components/ScoringComponent.vue";
export default {
  name: "ScoringTable",
  components: {
    ScoringComponent,
  },
  data() {
    return {
      opinionText: "",
      achievementDetail: {},
      project_xid: "",
      xid: "",
      score3: null,
      score1: null,
      score2: null,
      scoreList: [],
      scoreTitle: "",
      scoreDetail: {},
      lookId:'',
      status:''
    };
  },
  mounted() {
    this.project_xid = this.$route.query.project_xid;
    this.xid = this.$route.query.xid;
    this.status = this.$route.query.status;
    this.lookId = this.$route.query.isLook;
    this.getAchievementDetail();
    this.getList();
  },
  methods: {
    getScore() {
      this.$API.getScoreDetail({ xid: this.xid }).then((res) => {
        this.scoreDetail = res.data;
        this.opinionText = res.data.expert_opinion;
        if (res.data.score_detail.length > 0) {
          const scoreMap = new Map(
            res.data.score_detail.map(({ dimension_id, option_id, option_score }) => [
              `${dimension_id}-${option_id}`,
              option_score,
            ])
          );

          const newArr = this.scoreList.map((dimension) => ({
            ...dimension,
            item: dimension.item.map((item) => {
              // 使用 dimension_id 和 item.id 构造唯一键来查找 score
              const key = `${dimension.id}-${item.id}`;
              return {
                ...item,
                currentScore: scoreMap.get(key) || item.currentScore, // 默认保留原有分数
              };
            }),
          }));
          this.scoreList = newArr;

        }

      });
    },
    //判断是否有未打分的选项
    checkCurrentScores(arr) {
      for (const dimension of arr) {
        for (const item of dimension.item) {
          if (!item.currentScore) {
            return false;
          }
        }
      }
      return true;
    },
    submit() {
      const result = this.checkCurrentScores(this.scoreList);
      if (!result) {
        this.$message.error("请打完所有分数");
        return;
      }
      // 转换数组
      const transformedArray = this.scoreList.flatMap((dimension) =>
        dimension.item.map((item) => ({
          dimension_id: dimension.id,
          option_id: item.id,
          option_score: item.currentScore,
        }))
      );

      this.$API
        .saveScore({
          xid: this.xid,
          expert_opinion: this.opinionText,
          score_detail: transformedArray,
        })
        .then((res) => {
          this.$message.success("提交成功");
          this.$router.go(-1);
        });
    },
    getDimensionScore(itemData) {
      return itemData.item.reduce(
        (sum, subItem) => sum + (subItem.currentScore || 0),
        0
      );
    },
    getTotalScore() {
      return this.scoreList.reduce(
        (sum, itemData) => sum + this.getDimensionScore(itemData),
        0
      );
    },
    getList() {
      this.$API.getScoreList({ xid: this.xid }).then((res) => {
        this.scoreTitle = res.data.form.form_name;
        this.scoreList = res.data.formDimension;
        //已结束才调用打分详情接口
        if(this.status == 2){
        this.getScore();
        }
      });
    },
    handleDownload(file) {
      if (!file.file_path) {
        this.$message.warning("文件路径不存在");
        return;
      }
      window.open(file.file_path, "_blank");
    },
    getAchievementDetail() {
      this.$API.getAchievementDetail({ xid: this.project_xid }).then((res) => {
        this.achievementDetail = res.data;
      });
    },
    handleRow(type) {
      switch (type) {
        case "goBack":
          this.$router.go(-1);
          break;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.subTitle {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 12px;
  color: #c2c2c2;
}
.file-item {
  i {
    margin-right: 10px;
    color: #409eff; /* 默认蓝色 */
    font-size: 18px;
  }
}
.goBackBtn {
  display: flex;
  justify-content: end;
  align-items: center;
  height: 100%;
  padding-right: 60px;
}
.goBack {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0px;
  height: 60px;
  background: #000000;
  border-radius: 0px 0px 0px 0px;
}
.sumScore {
  text-align: right;
}
.pfDiv {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.mt10 {
  margin-top: 10px;
}
.dfCountNumSpan {
  text-decoration: underline;
}
.dfCountNum {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #ed4014;
  line-height: 30px;
}
.dfTitle {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #595959;
  line-height: 30px;
}
.dfNum {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #2f86ff;
  line-height: 30px;
}
.formHeaderTextSpan {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #ed4014;
  margin-left: 10px;
}
.mt30 {
  margin-top: 30px;
}
.formHeaderText {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #231815;
}

.formHeader {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.line {
  width: 3px;
  height: 19px;
  background: #2f86ff;
  margin-right: 10px;
}
.scoringTableDiv {
  display: flex;
  justify-content: space-between;
}
.leftDiv {
  width: 58%;
  background: #fff;
  border-radius: 6px;
  padding: 28px;
  height: 700px;
  overflow-y: auto;
}
.rightDiv {
  width: 40%;
  border-radius: 6px;
  background: #fff;
  padding: 42px;
  height: 700px;
  overflow-y: auto;
}
.nameTitle {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 20px;
  color: #595959;
  line-height: 30px;
  margin-top: 30px;
  margin-bottom: 10px;
}
.reTitle {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 20px;
  color: #595959;
  line-height: 30px;
  text-align: center;
}
</style>